module.exports = __webpack_public_path__ + "img/logo.b294c879.png";